// src/components/Sections/Home/Alliances/Alliances.jsx
import React, { useState, useEffect, useRef } from "react";
import "./alliances.css";
import { alliancesData } from "../../../../json/sections/Home/alliances";

const Alliances = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(5);
  const [containerWidth, setContainerWidth] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const refContainer = useRef(null);

  // Handle responsive number of slides
  useEffect(() => {
    const updateLayout = () => {
      if (refContainer.current) {
        const width = refContainer.current.offsetWidth;
        setContainerWidth(width);

        if (width <= 767) {
          setVisibleSlides(1);
        } else if (width <= 1023) {
          setVisibleSlides(3);
        } else {
          setVisibleSlides(4);
        }
      }
    };

    window.addEventListener("resize", updateLayout);
    updateLayout();
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  // Auto-scroll carousel every 3s, pause on hover
  useEffect(() => {
    // don't auto-scroll if paused or not enough items
    if (isPaused || alliancesData.length <= visibleSlides) return;

    const maxIndex = Math.max(0, alliancesData.length - visibleSlides);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % (maxIndex + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [visibleSlides, isPaused]);

  const getTransform = () => {
    const spacing = 20;
    const slideWidth = containerWidth / visibleSlides;
    return `translateX(-${currentIndex * (slideWidth + spacing)}px)`;
  };

  const getTrackWidth = () => {
    const spacing = 20;
    const slideWidth = containerWidth / visibleSlides;
    return alliancesData.length * slideWidth + (alliancesData.length - 1) * spacing;
  };

  return (
    <div
      className="alliances-container"
      style={{
        backgroundImage: `url('/assets/imgs/home/alliances/fondo.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat",
        height: "100%",
        width: "100%",
      }}
    >
      <div className="carousel" ref={refContainer}>
        <div className="container">
          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-6">
              <div className="alliances-header line-height-clss">
                <h5 className="line-height-clss">MEET SOME OF OUR</h5>
                <h1 className="line-height-clss">Business Alliances</h1>
              </div>
            </div>
            <div className="col-md-3"></div>
          </div>
        </div>

        <div className="carousel-track-container">
          <ul
            className="carousel-track"
            style={{
              transform: getTransform(),
              width: `${getTrackWidth()}px`,
            }}
          >
            {alliancesData.map((cliente, index) => {
              const slideWidth = containerWidth / visibleSlides;
              const imgUrl = cliente.src || "";
              return (
                <li
                  key={index}
                  className="carousel-slide"
                  style={{ width: `${slideWidth}px`, marginRight: "20px" }}
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                >
                  <a href={cliente.link} target="_blank" rel="noopener noreferrer">
                    <div
                      className="carousel-image"
                      style={{ backgroundImage: `url(${imgUrl})` }}
                    />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Alliances;
